import { Card, Box, IconButton, Tooltip, useTheme } from '@mui/joy'
import { OrderRouteMap } from 'pages/dashboard/pages/dispatcher/pages/dispatcher-emails/components/EmailContent/components/EmailCard/components'
import DirectionsIcon from '@mui/icons-material/Directions'

interface Props {
    polyline: string
    openInGoogleMaps: () => void
    onWeatherUpdate?: (warnings: Array<{ condition: string; location: string; temp?: number; icon: string }>) => void
}

export const MapCard: React.FC<Props> = ({ polyline, openInGoogleMaps, onWeatherUpdate }) => {
    const theme = useTheme()
    const isDarkMode = theme.palette.mode === 'dark'

    return (
        <Card
            variant="outlined"
            sx={{
                overflow: 'hidden',
                borderRadius: 'md',
                boxShadow: 'sm',
                position: 'relative',
            }}
        >
            <OrderRouteMap polyline={polyline} onWeatherUpdate={onWeatherUpdate} />
            <Box
                sx={{
                    position: 'absolute',
                    top: '15px',
                    right: '20px',
                }}
            >
                <Tooltip title="Open in Google Maps" placement="left">
                    <IconButton
                        variant="soft"
                        color="neutral"
                        size="md"
                        sx={{
                            backgroundColor: 'background.surface',
                            color: 'text.secondary',
                            boxShadow: isDarkMode ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.15)',
                            '&:hover': {
                                boxShadow: isDarkMode ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.2)',
                                backgroundColor: 'background.surface',
                            },
                            transition: 'box-shadow 0.2s ease-in-out',
                        }}
                        onClick={openInGoogleMaps}
                    >
                        <DirectionsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </Card>
    )
}
